var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echart',{attrs:{"options":_vm.options,"id":"air-quality-forecast","height":"400px","width":"340px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }